/**
 * Добавляет UTC offset (+04:30) к ISO-строке даты.
 * @param {string} isoString - Дата в формате ISO.
 * @param {string} timeString - Смещение времени (например "+04:30").
 * @returns {string} Новая дата в формате ISO с применённым смещением.
 */
function addTimeToISOString(isoString, timeString) {
  if (!timeString) {
    return isoString;
  }

  const date = new Date(isoString);

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(date)) {
    return "";
  }

  const timeParts = timeString.replace("+", "").split(":");
  const hoursToAdd = parseInt(timeParts[0], 10);
  const minutesToAdd = timeParts.length > 1 ? parseInt(timeParts[1], 10) : 0;

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(hoursToAdd) || isNaN(minutesToAdd)) {
    return "";
  }

  date.setHours(date.getHours() + hoursToAdd);
  date.setMinutes(date.getMinutes() + minutesToAdd);

  return date.toISOString();
}

export default addTimeToISOString;
